import { useQuery } from "@apollo/client/react";
import paths from "config/routePaths";
import { GetAssignedSites } from "hooks/apollo/site/site.gql";
import Authorization from "policies/Authorization";
import React from "react";
import SiteIndexView from "./SiteIndexView";

export default function SiteIndexContainer() {
  const { data: assignedSitesData, loading: loadingSites } = useQuery(GetAssignedSites);
  const policy = Authorization.usePolicy();

  if (loadingSites) return null;

  const canCreateSite = policy.canCreate(Authorization.EntityTypes.Site);
  const canUpdateCompany = policy.canUpdate(Authorization.EntityTypes.Company);
  const createSitePath = paths.siteNew;

  const { assignedSites } = assignedSitesData;

  return (
    <SiteIndexView
      assignedSites={assignedSites}
      canCreateSite={canCreateSite}
      canUpdateCompany={canUpdateCompany}
      createSitePath={createSitePath}
    />
  );
}
